
// Define available languages
export type Language = 'english' | 'italian' | 'spanish' | 'german' | 'french' | 'polish' | 'portuguese';

// Define language labels for display
export const languageOptions: { value: Language; label: string }[] = [
  { value: 'english', label: 'English' },
  { value: 'italian', label: 'Italiano' },
  { value: 'spanish', label: 'Español' },
  { value: 'german', label: 'Deutsch' },
  { value: 'french', label: 'Français' },
  { value: 'polish', label: 'Polski' },
  { value: 'portuguese', label: 'Português' }
];

// Import all translations
import { english } from './english';
import { italian } from './italian';
import { spanish } from './spanish';
import { german } from './german';
import { french } from './french';
import { polish } from './polish';
import { portuguese } from './portuguese';

// Export all translations in a single object
export const translations = {
  english,
  italian,
  spanish,
  german,
  french,
  polish,
  portuguese
};

// Create a type for our translations structure
export type TranslationType = typeof english;
